/* global axios */
import ApiClient from './ApiClient';

class ReportSchedulesAPI extends ApiClient {
  constructor() {
    super('report_schedules', { accountScoped: true });
  }

  sendTest(id) {
    return axios.post(`${this.url}/${id}/send_test`);
  }
}

export default new ReportSchedulesAPI();
